/**
 * features/customers/use-customer-search.ts — ค้นหาลูกค้าแบบ autocomplete สำหรับใช้ในฟอร์มเอกสาร
 */

import { useQuery } from '@tanstack/react-query';
import { api, queryString } from '~/lib/api';
import type { Paginated, Party } from '~/lib/types';

export function useCustomerSearch(search: string) {
  return useQuery({
    queryKey: ['customers', 'search', search],
    queryFn: () =>
      api.get<Paginated<Party>>(
        `/api/customers${queryString({ page: 1, pageSize: 8, search })}`,
      ),
    enabled: search.trim().length > 0,
  });
}
